<template>
  <div class="ActivityDiscount">
    <div class='titlebg'>
      <img  class="bg" :src="imgUrl1" alt=""  >
      <div class="playRadio">
        <img :src="imgUrl2" alt="" id="videosBg" @click="getRideo"  v-if="imgshow">
        <video  controls    id="videos" style="width: 100%; height:100%;object-fit:fill" autoplay="autoplay" v-if="!imgshow"  >
          <source :src="videoUrl" type="video/mp4">
        </video>      
      </div>
    </div>
    <div class="bannerContent">
      <img  class="bg" :src="imgUrl3" alt="" >
      <img :src="imgUrl4" alt="" class='btnimg'>
    </div>
    <div class="btn btn1">
      <div @click="getActivityDiscount(2)"></div>
    </div>
    <!-- <div class="btn btn2">
      <div @click="getActivityDiscount(2)"></div>
    </div> -->
  </div>
</template>

<script>
import { orderSource } from "@/utils/env";
import { getConsumerCoupons, DrawCoupon } from "@/utils/api";
export default {
  name: 'reWuhan',
  data(){
    return {
      imgUrl1: 'https://cms.dafang24.com/aliapp/20191012/wuhansBg.png',
      imgUrl2: 'https://cms.dafang24.com/aliapp/20191012/videosBg.png',
      imgUrl3: 'https://cms.dafang24.com/aliapp/20191012/wuhansRule.png',
      imgUrl4: 'https://cms.dafang24.com/aliapp/20191012/getBtn.png',
      videoUrl:"https://cms.dafang24.com/aliapp/20191012/city.mp4",
      couponList: [],
      couponList1: [
        {
          name: "武汉 3天免费用车",
          OfferID: 275
        }
      ],
      couponList2: [
        {
          name: "租1天送1天，最高优惠100元",
          OfferID: 276
        },
        {
          name: "租2天送2天，最高优惠200元",
          OfferID: 277
        },
        {
          name: "租3天送3天，最高优惠300元",
          OfferID: 278
        }
      ],
      imgshow:true
    }
  },
  created () {},
  mounted () {},
  methods: {
    getActivityDiscount(type=0){
      if( localStorage.getItem('token') ){
        let couponList = this.couponList;
        if(type==1) { couponList = this.couponList1; }
        if(type==2) { couponList = this.couponList2; }
        this.consumerCouponsFn(couponList);
      } else {
        this.flexible.showToast({content:'请先登陆/注册！'})
      }
    },
    getRideo(){
      this.imgshow=false;
    },
    goHome () {
      if( orderSource==17 ){
        window.webkit.messageHandlers.goHome.postMessage(null);
      } else if ( orderSource==16 ){
        dfpanda.goHome();
      }
    },
    async consumerCouponsFn (copList) { // 获取用户优惠券
      let res = await getConsumerCoupons();
      if( res.Code==100 ){
        let uCoupon = res.Data || [];
        if( uCoupon.length ){
          for( let i in uCoupon ){
            for( let j in copList ){
              if( uCoupon[i].OfferID == copList[j].OfferID ){
                copList.splice(j, 1)
              }
            }
          }
        }
        console.log(copList);
        if( copList.length ){
          let lastRes = false;
          for( let item of copList ){
            let gRes = await this.getDrawCoupon(item.OfferID);
            if( gRes ){ lastRes = gRes }
          }
          if( lastRes ){
            this.flexible.showToast({
              duration:1200,
              content:'领取成功！去租车',
              success:()=>{
                this.goHome()
              }
            });
          } else {
            this.flexible.showToast({content:'领取失败，请重试'})
          }
        } else {
          this.flexible.showToast({
            duration:1200,
            content:'领取成功！去租车',
            success:()=>{
              this.goHome()
            }
          })
        }
      }
    },
    async getDrawCoupon ( offerID ) {
      let res = await DrawCoupon({
        data: {
          OfferID: offerID,
          orgID: 0
        },
        isLoading: 1,
        loadContent: '获取优惠券...'
      });
      if( res.Code==100 ){
        return true;
      }
      return false;
    }
  }
}
</script>
<style lang="scss" scoped>
  .ActivityDiscount {
    position: relative;
    img {
      width: 100%;
    }
    .btn {
      position: absolute;
      left: 0;
      width: 100%;
      text-align: center;
      div {
        display: inline-block;
        /*background-color: rgba(0,0,0, .5);*/
      }
    }
    .btn1 {
      top: 1940px;
      div {
        width: 400px;
        height: 120px;
      }
    }
    .btn2  {
      top: 2760px;
      div {
        width: 600px;
        height: 120px;
      }
    }
  }
  .titlebg{
        position: relative;
    }        
    .titlebg .playRadio{
        width:600px;
        height:960px;
        position: absolute;
        left: 0; 
        right: 0; 
        top:320px;
        margin-left: auto; 
        margin-right: auto;
    }  
    .titlebg .playRadio img{
        width:100%;
        height:100%;
    }      
    .bannerContent{
        position: absolute;
        margin-top:-40px;
    }
    .bannerContent .btnimg{
            width: 600px;
            position: absolute;
            top:620px;
            left:75px;
        }
    
</style>